import React, { Component, Fragment } from "react";
import DefectReport from "./LineInspection/DefectReport";
import SwitchReport from "./Switch/switchReport";
import TrackDisturbanceReport from "./TrackDisturbance/trackDisturbanceReport";
import DetailedSwitchInspection from "./Switch/DetailedSwitchInspectionSelection";
import { dateSortArrayByField } from "../../../utils/sortingMethods";
import YardTrackDefectReport from "./YardTrackInspection/YardTrackDefectReport";
import MonthlyBridgeInspection from "./Bridge/monthlyBridgeInspection";
import CurveReport from "./CurveReport/CurveReport";
import DetailedTurnoutInspection from "./EtrSwitchReport/detailedTurnoutInspectionReport";
import { SignatureImage } from "../utils/SignatureImage";
import DetailedTurnoutInspectionReport from "./Ontario/DetailedTurnoutInspectionReport";
import MonthlyTurnoutInspectionReport from "./Ontario/MonthlyTurnoutInspectionReport";
import JobBriefingManager from "../../jobBriefing/JobBrieifingReport/JobBriefingManager";
import NOPB_SwitchInspectionReport from "../NOPB/SwitchInspectionReport";
import TNW_SwitchInspectionReport from "../TNW/SwitchInspectionReport";
import ONR_DetailedAnnualInspectionOfPrivatePublicAssetsReport from "../ONR/DetailedAnnualInspectionOfPrivatePublicAssetsReport";
import SFRTA_DailyMaterialUsageReport from "../SFRTA/DailyMaterialUsageReport";
import SFRTA_RecordofDisturbanceForRailAndTrackComponentsReport from "../SFRTA/RecordofDisturbanceForRailAndTrackComponentsReport";
import SFRTA_TrackDisturbanceReport from "../SFRTA/TrackDisturbanceReport";
import ONR_DerailInspectionAnnual from "../ONR/DerailInspectionAnnual";
import BRC_InertRetardersInspectionReport from "../BRC/InertRetardersInspectionReport";
import { CRUDFunction } from "../../../reduxCURD/container";
import SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionForm from "../SEPTA/TrackSectionTurnoutAndSpecialWorkInspectionForm";
import ONR_CwrRailLayingAndDistressingRecord from "../ONR/CwrRailLayingAndDistressingRecord";
import SEPTA_DailyTrackInspectionReport from "../SEPTA/DailyTrackInspectionReport";
import ONR_BallastRequirementsForm from "../ONR/BallastRequirementsForm";
import ONR_BeaverDamsReport from "../ONR/BeaverDamsReport";
import ONR_BrushCuttingRequirements from "../ONR/BrushCuttingRequirements";
import ONR_ChangeInCurveReport from "../ONR/ChangeInCurveReport";
import ONR_CwrMaintenanceRecordForm from "../ONR/CwrMaintenanceRecordForm";
import ONR_DitchingReport from "../ONR/DitchingReport";
import ONR_SurfacingAndLiningRequirements from "../ONR/SurfacingAndLiningRequirements";
import ONR_TrackTieRequirements from "../ONR/TrackTieRequirements";
import ONR_WeedSprayingRequirements from "../ONR/WeedSprayingRequirements";
import ONR_InServiceRailFailureReport from "../ONR/InServiceRailFailureReport";
import ONR_TrackBuckleReport from "../ONR/TrackBuckleReport";
import ONR_SwitchTieRequirements from "../ONR/SwitchTieRequirements";
import ETR_DetailedCrossingReport from "../ETR/DetailedCrossingReport";
import ETR_MonthlyCulvertReport from "../ETR/MonthlyCulvertReport";
import OnImagesLoaded from "react-on-images-loaded";
import SpinnerLoader from "../../Common/SpinnerLoader";
import { ToastService } from "../../../utils/toastify";
import TopMessageBar from "../../../libraries/TopMessageBar";
import { languageService } from "../../../Language/language.service";
import ScrollToTop from "../../Common/ScrollToTop/index";
import FRA_TrackViolationReport from "../FRA/TrackViolationReport";
import SCFE_RecordOfDisturbanceReport from "../SCFE/RecordOfDisturbanceReport";
import SCFE_JointBarFractureReport from "../SCFE/JointBarFractureReport";
import SCFE_SwitchInspectionReport from "../SCFE/SwitchInspectionReport";
import WorkGangReport from "../PATH/WorkGangReport";

const LOADING_FAILED_MESSAGE = languageService("Failed to load some images in the report.");

class MultiReport extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showReports: false,
      success: true,
    };
  }
  renderReports() {
    let reports = null;
    let multiReports = this.props.reportInspections ? this.props.reportInspections.length : 0;
    if (this.props.reportInspections) {
      let filteredReports = dateSortArrayByField(this.props.reportInspections, "date");

      reports = filteredReports.map((inspec) => {
        return reportSelector(this.props, this.props.reportName, inspec, multiReports);
      });
    }
    return reports;
  }
  loadedReportsSucessCallback(success) {
    this.setState({ showReports: true, success: success });
    if (!success) {
      ToastService.Error(`${languageService("Error")}:`, LOADING_FAILED_MESSAGE);
    }
  }
  render() {
    const { success } = this.state;
    return (
      <div style={{ position: "relative" }}>
        {success ? null : <TopMessageBar message={LOADING_FAILED_MESSAGE} type={"Error"} />}
        <SpinnerLoader spinnerLoading={!this.state.showReports} />
        <OnImagesLoaded
          onLoaded={() => this.loadedReportsSucessCallback(true)}
          onTimeout={() => this.loadedReportsSucessCallback(false)}
          timeout={15000}
          delay={500}
        >
          <ScrollToTop>
            <div style={{ opacity: this.state.showReports ? 1 : 0 }}>{this.renderReports()}</div>
          </ScrollToTop>
        </OnImagesLoaded>
      </div>
    );
  }
}

export default MultiReport;

function reportSelector(props, report, inspec, multiReports) {
  let obj = {
    "Line Inspection Report": (
      <DefectReport
        inspec={inspec}
        key={inspec._id}
        signatureImage={inspec && inspec.user && inspec.user.signature}
        userName={inspec && inspec.user && inspec.user.name}
        InspectionReportType={props.InspectionReportType}
        usersSignatures={props.usersSignatures}
        nonFraCode={props.nonFraCode}
        disableRule213={props.disableRule213}
      />
    ),
    "Line Inspection and Repair Report": (
      <SEPTA_DailyTrackInspectionReport
        inspec={inspec}
        key={inspec._id}
        signatureImage={inspec && inspec.user && inspec.user.signature}
        userName={inspec && inspec.user && inspec.user.name}
        InspectionReportType={props.InspectionReportType}
        usersSignatures={props.usersSignatures}
        nonFraCode={props.nonFraCode}
      />
    ),
    "Yard Inspection Report": (
      <YardTrackDefectReport
        inspec={inspec}
        key={inspec._id}
        signatureImage={inspec && inspec.user && inspec.user.signature}
        usersSignatures={props.usersSignatures}
        nonFraCode={props.nonFraCode}
      />
    ),
    "Switch Report": <SwitchReport inspec={inspec} key={inspec._id} nonFraCode={props.nonFraCode} />,
    "Track Disturbance Report": <SFRTA_TrackDisturbanceReport inspec={inspec} key={inspec._id} />,
    "Derail Annual Inspection": <ONR_DerailInspectionAnnual inspec={inspec} key={inspec._id} />,
    "Yard Switch Inspection Report": (
      <TNW_SwitchInspectionReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),

    // Yard Switch Inspection Report
    "Inert Retarder Report": <BRC_InertRetardersInspectionReport inspec={inspec} key={inspec._id} />,
    "Detailed Switch Machine Report": (
      <SEPTA_TrackSectionTurnoutAndSpecialWorkInspectionForm
        inspec={inspec}
        key={inspec._id}
        signatureImage={inspec && inspec.user && inspec.user.signature}
      />
    ),
    "Detailed Annual Crossing Inspection": <ONR_DetailedAnnualInspectionOfPrivatePublicAssetsReport inspec={inspec} key={inspec._id} />,
    "Weld Report": <SFRTA_RecordofDisturbanceForRailAndTrackComponentsReport inspec={inspec} key={inspec._id} />,
    "Daily Material Usage Report": <SFRTA_DailyMaterialUsageReport inspec={inspec} key={inspec._id} materialTypes={props.materialTypes} />,
    "CWR Rail Laying Record": <ONR_CwrRailLayingAndDistressingRecord inspec={inspec} key={inspec._id} />,
    "CWR Maintenance Record": (
      <ONR_CwrMaintenanceRecordForm inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "ONR - In Service Rail Failure Report": (
      <ONR_InServiceRailFailureReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "Track Buckle Report": <ONR_TrackBuckleReport inspec={inspec} key={inspec._id} />,
    "Change In Curve Report": <ONR_ChangeInCurveReport inspec={inspec} key={inspec._id} />,
    "ONR - Ballast Requirements": <ONR_BallastRequirementsForm inspec={inspec} key={inspec._id} />,
    "ONR - Beaver Dams Report": <ONR_BeaverDamsReport inspec={inspec} key={inspec._id} />,
    "ONR - Brush Cutting Requirements": <ONR_BrushCuttingRequirements inspec={inspec} key={inspec._id} />,
    "ONR - Ditching Report": <ONR_DitchingReport inspec={inspec} key={inspec._id} />,
    "ONR - Surface Lining Requirements": <ONR_SurfacingAndLiningRequirements inspec={inspec} key={inspec._id} />,
    "ONR - Track Tie Requirements": <ONR_TrackTieRequirements inspec={inspec} key={inspec._id} />,
    "ONR - Weed Spraying Requirements": <ONR_WeedSprayingRequirements inspec={inspec} key={inspec._id} />,
    "ONR - Switch Tie Requirements": (
      <ONR_SwitchTieRequirements inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "Detailed Switch Inspection": (
      <DetailedSwitchInspection
        inspec={inspec}
        key={inspec._id}
        handleReportPrint={props.printbuttonhandler.show}
        handleReportPrintOff={props.printbuttonhandler.hide}
        multi={multiReports}
        isMulti={props.isMulti}
        usersSignatures={props.usersSignatures}
        signatureImage={inspec && inspec.user && inspec.user.signature}
      />
    ),
    "Bridge Inspection Report": (
      <MonthlyBridgeInspection inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "Inspection of Curves": (
      <CurveReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "Turnout Inspection Report": (
      <DetailedTurnoutInspection inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "Turnout Inspection Report ONR": (
      <DetailedTurnoutInspectionReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),

    "Track Violation Report": (
      <FRA_TrackViolationReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),

    "SCFE Record Of Disturbance Report": (
      <SCFE_RecordOfDisturbanceReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),

    "SCFE Joint Bar Fracture Report": <SCFE_JointBarFractureReport inspec={inspec} key={inspec._id} />,
    "Monthly Turnout Report SCFE": (
      <SCFE_SwitchInspectionReport
        inspec={inspec}
        key={inspec._id}
        signatureImage={inspec && inspec.user && inspec.user.signature}
        usersSignatures={props.usersSignatures}
      />
    ),
    "Monthly Turnout Report ONR": (
      <MonthlyTurnoutInspectionReport
        inspec={inspec}
        key={inspec._id}
        signatureImage={inspec && inspec.user && inspec.user.signature}
        usersSignatures={props.usersSignatures}
      />
    ),
    "Safety Briefing": (
      <JobBriefingManager inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "Switch Inspection Report": (
      <NOPB_SwitchInspectionReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),

    "ETR - Detailed Crossing Report": (
      <ETR_DetailedCrossingReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "ETR - Monthly Culvert Report": (
      <ETR_MonthlyCulvertReport inspec={inspec} key={inspec._id} signatureImage={inspec && inspec.user && inspec.user.signature} />
    ),
    "Work Gang Report": <WorkGangReport inspec={inspec} key={inspec._id} materialTypes={props.materialTypes} />,
  };
  return obj[report] ? obj[report] : null;
}



// WEBPACK FOOTER //
// ./src/components/Reports/Timps/MultiReport.jsx